import { z } from "zod";

export const complianceStatsResourceCountResultSchema = z.object({
  "ResourceCount.resourceCount": z.string().optional(),
});

export const complianceStatsResourceCountResultArraySchema = z
  .array(complianceStatsResourceCountResultSchema)
  .nullish();

export const complianceStatsDistinctResourcesResultSchema = z.object({
  "ControlSignal.distinctResources": z.string().optional(),
});

export const complianceStatsDistinctResourcesResultArraySchema = z
  .array(complianceStatsDistinctResourcesResultSchema)
  .nullish();

export type ComplianceStatsResourceCountResult = z.infer<
  typeof complianceStatsResourceCountResultSchema
>;

export type ComplianceStatsDistinctResourcesResult = z.infer<
  typeof complianceStatsDistinctResourcesResultSchema
>;
